'use client';

import { c as _c } from "react/compiler-runtime";
import Modal from '../../HOC/Modal';
import DraftPostsList from './DraftPostsList';
import { InlineReplyLayout } from './InlineReplyLayout';
import { useNewPostContext } from './NewPostContext';
import { NewPostLayout } from './NewPostLayout';
import { TopLevelReplyLayout } from './TopLevelReplyLayout';
const ConditionalModal = t0 => {
  const $ = _c(11);
  let children;
  let inline;
  let isReplyMode;
  let modalProps;
  if ($[0] !== t0) {
    ({
      inline,
      isReplyMode,
      children,
      ...modalProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = inline;
    $[3] = isReplyMode;
    $[4] = modalProps;
  } else {
    children = $[1];
    inline = $[2];
    isReplyMode = $[3];
    modalProps = $[4];
  }
  if (inline) {
    const t1 = `mt-3 w-full max-w-full ${isReplyMode ? "" : "overflow-y-auto rounded-lg border border-ds-border-subtle bg-background-light p-4"}`;
    let t2;
    if ($[5] !== children || $[6] !== t1) {
      t2 = <div className={t1}>{children}</div>;
      $[5] = children;
      $[6] = t1;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    return t2;
  }
  let t1;
  if ($[8] !== children || $[9] !== modalProps) {
    t1 = <Modal {...modalProps}>{children}</Modal>;
    $[8] = children;
    $[9] = modalProps;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  return t1;
};
export const NewPostBody = () => {
  const $ = _c(14);
  const {
    saveDraftConfModalOpen,
    moderationConfModalOpen,
    draftsListModalOpen,
    draftItemSelectHandler,
    setDraftsListModalOpen,
    isReplyMode,
    isTopLevelReplyModal,
    inline,
    closeOrSaveDraft
  } = useNewPostContext();
  let t0;
  if ($[0] !== closeOrSaveDraft || $[1] !== inline || $[2] !== isReplyMode || $[3] !== isTopLevelReplyModal || $[4] !== moderationConfModalOpen || $[5] !== saveDraftConfModalOpen) {
    t0 = !saveDraftConfModalOpen && !moderationConfModalOpen && (isTopLevelReplyModal ? <TopLevelReplyLayout /> : <ConditionalModal inline={inline} isReplyMode={isReplyMode} closeHandler={closeOrSaveDraft}>{isReplyMode ? <InlineReplyLayout /> : <NewPostLayout />}</ConditionalModal>);
    $[0] = closeOrSaveDraft;
    $[1] = inline;
    $[2] = isReplyMode;
    $[3] = isTopLevelReplyModal;
    $[4] = moderationConfModalOpen;
    $[5] = saveDraftConfModalOpen;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  let t1;
  if ($[7] !== draftItemSelectHandler || $[8] !== draftsListModalOpen || $[9] !== setDraftsListModalOpen) {
    t1 = draftsListModalOpen && <DraftPostsList closeHandler={() => setDraftsListModalOpen(false)} draftItemSelectHandler={draftItemSelectHandler} />;
    $[7] = draftItemSelectHandler;
    $[8] = draftsListModalOpen;
    $[9] = setDraftsListModalOpen;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  let t2;
  if ($[11] !== t0 || $[12] !== t1) {
    t2 = <>{t0}{t1}</>;
    $[11] = t0;
    $[12] = t1;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  return t2;
};